// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__ZcLYo","inline":"loading_inline__xKEHb","dots":"loading_dots__BAiwA","dotFlashing":"loading_dotFlashing__nB77w"};